// src/types/commonParts.js

// 共通パーツの種類
export const PART_TYPES = {
    HEADER: 'header',
    FOOTER: 'footer',
    NAVIGATION: 'navigation',
    SIDEBAR: 'sidebar',
    CTA: 'cta' // Call to Action
};

// パーツの種類の表示名
export const PART_TYPE_LABELS = {
    [PART_TYPES.HEADER]: 'ヘッダー',
    [PART_TYPES.FOOTER]: 'フッター',
    [PART_TYPES.NAVIGATION]: 'ナビゲーション',
    [PART_TYPES.SIDEBAR]: 'サイドバー',
    [PART_TYPES.CTA]: 'CTA（行動喚起）'
};


// デフォルトのパーツテンプレート
export const DEFAULT_PART_TEMPLATES = {
    [PART_TYPES.HEADER]: {
        name: 'シンプルヘッダー',
        description: '基本的なロゴとナビゲーションを含むヘッダー',
        html: `<!-- ヘッダー -->
<header class="site-header">
    <div class="container">
        <div class="header-content">
            <div class="logo">
                <a href="/" class="logo-link">
                    <h1>サイト名</h1>
                </a>
            </div>
            <nav class="main-nav">
                <ul class="nav-list">
                    <li><a href="/">ホーム</a></li>
                    <li><a href="/about">会社概要</a></li>
                    <li><a href="/services">サービス</a></li>
                    <li><a href="/contact">お問い合わせ</a></li>
                </ul>
            </nav>
        </div>
    </div>
</header>`,
        css: `/* ヘッダースタイル */
.site-header {
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    padding: 1rem 0;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo h1 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
}

.logo-link {
    text-decoration: none;
    color: inherit;
}

.main-nav ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 2rem;
}

.main-nav a {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    transition: color 0.3s ease;
}

.main-nav a:hover {
    color: #007bff;
}

@media (max-width: 768px) {
    .header-content {
        flex-direction: column;
        gap: 1rem;
    }
    
    .main-nav ul {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }
}`
    },
    [PART_TYPES.FOOTER]: {
        name: 'シンプルフッター',
        description: '基本的なリンクとコピーライトを含むフッター',
        html: `<!-- フッター -->
<footer class="site-footer">
    <div class="container">
        <div class="footer-content">
            <div class="footer-section">
                <h3>会社名</h3>
                <p>あなたのビジネスをサポートします。</p>
            </div>
            <div class="footer-section">
                <h4>リンク</h4>
                <ul>
                    <li><a href="/">ホーム</a></li>
                    <li><a href="/about">会社概要</a></li>
                    <li><a href="/privacy">プライバシーポリシー</a></li>
                    <li><a href="/terms">利用規約</a></li>
                </ul>
            </div>
            <div class="footer-section">
                <h4>お問い合わせ</h4>
                <p>Email: info@example.com</p>
                <p>Tel: 03-1234-5678</p>
            </div>
        </div>
        <div class="footer-bottom">
            <p>&copy; 2025 会社名. All rights reserved.</p>
        </div>
    </div>
</footer>`,
        css: `/* フッタースタイル */
.site-footer {
    background: #333;
    color: #fff;
    padding: 2rem 0 1rem;
    margin-top: 3rem;
}

.footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 2rem;
}

.footer-section h3,
.footer-section h4 {
    margin: 0 0 1rem 0;
    color: #fff;
}

.footer-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-section ul li {
    margin-bottom: 0.5rem;
}

.footer-section a {
    color: #ccc;
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-section a:hover {
    color: #fff;
}

.footer-bottom {
    border-top: 1px solid #555;
    padding-top: 1rem;
    text-align: center;
    color: #ccc;
}

.footer-bottom p {
    margin: 0;
}`
    }
};
